  export const isDigit = (value:string):Boolean => {
    const numberValue = Number(value)
    return !isNaN(numberValue);
  }